export default __webpack_public_path__ + "static/media/duck-hunting.4ee5c5e5.jpg";